<template>
  <div class="ui-date-input">
    <CalendarDays class="ui-date-input__icon" :size="18" aria-hidden="true" />

    <UiInput v-bind="$attrs" :model-value="modelValue" type="date" @update:model-value="onInput" />
  </div>
</template>

<script setup lang="ts">
import { CalendarDays } from "lucide-vue-next";

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    modelValue?: string | null;
  }>(),
  {
    modelValue: "",
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const onInput = (value: string): void => {
  emit("update:modelValue", value);
};
</script>
